import type { NavigateFunction } from 'react-router-dom';

type LoadState = 'loading' | 'ok' | 'not_found' | 'error';

export function BoardLoadingStates({
  state,
  navigate,
}: {
  state: LoadState;
  navigate: NavigateFunction;
}) {
  if (state === 'not_found') {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-4 bg-neutral-900 text-white/80 px-6 text-center">
        <div className="text-3xl">🗒️</div>
        <div className="text-base font-medium">这块黑板不在了</div>
        <div className="text-sm opacity-70">链接可能已失效，或被管理员归档。</div>
        <button
          onClick={() => navigate('/')}
          className="mt-2 px-4 py-2 rounded-md bg-amber-400 text-neutral-900 text-sm font-semibold hover:bg-amber-300"
        >
          返回首页
        </button>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-4 bg-neutral-900 text-white/80 px-6 text-center">
        <div className="text-3xl">⚠️</div>
        <div className="text-base font-medium">加载失败</div>
        <div className="text-sm opacity-70">网络或服务异常，请稍后再试。</div>
        <div className="flex gap-2 mt-2">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-md bg-amber-400 text-neutral-900 text-sm font-semibold hover:bg-amber-300"
          >
            重试
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 rounded-md border border-white/20 text-sm hover:bg-white/10"
          >
            返回首页
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full flex flex-col items-center justify-center gap-3 bg-neutral-900 text-white/80">
      <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden>
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeOpacity=".25"
          strokeWidth="3"
        />
        <path
          d="M21 12a9 9 0 00-9-9"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="0.9s"
            from="0 12 12"
            to="360 12 12"
            repeatCount="indefinite"
          />
        </path>
      </svg>
      <span className="text-sm tracking-wide">加载画板…</span>
    </div>
  );
}
